export default "__VITE_ASSET__Br3y9wNt__"